/* PDP clone kit – journey timeline: a step is active while its bottom is at least 200 px above the bottom of the
   screen (the original's rule, which also turns it off again when scrolled back). The observer's area runs from far
   above the screen to 200 px above its bottom; a step fully inside it is active. No scroll listener. */
(function () {
  'use strict';
  function init(root) {
    var steps = (root || document).querySelectorAll('[data-journey-step]:not([data-jr-ready])');
    if (!steps.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.classList.toggle('is-active', en.intersectionRatio >= 0.999 || (en.isIntersecting && en.boundingClientRect.bottom <= en.rootBounds.bottom + 0.5));
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 0.999, 1], rootMargin: '100000px 0px -200px 0px' });
    steps.forEach(function (s) { s.setAttribute('data-jr-ready', ''); io.observe(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
